function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React from "react";
import SocialActivities from "../containers/SocialActivities";
import last from "lodash/last";
import isFunction from "lodash/isFunction";
import classNames from "classnames";
import SocialMemberBubble from "../containers/SocialMemberBubble";
import Icon from "./Icon";
import store from "../store";
import isEqual from "lodash/isEqual";
import { fetchAvatars } from "../actions";
import { injectIntl } from "react-intl";
var hasClassList = !!document.body.classList;
var linkify = function(inputText) {
    var replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    var replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
    var replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    var replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
    return replacedText;
};
var _React_Component;
var SocialTopic = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(SocialTopic, _superClass);
    var _super = _createSuper(SocialTopic);
    function SocialTopic(props) {
        _classCallCheck(this, SocialTopic);
        var _this;
        _this = _super.call(this, props);
        _this.renderAssets = function(activity) {
            var assetCount = (activity.assets ? activity.assets.length : activity.asset_count) || 0;
            return assetCount ? /*#__PURE__*/ React.createElement("ul", {
                className: "social-topic__attachments"
            }, activity.assets.map(function(asset) {
                var assetCss = classNames("attachment", {
                    "attachment--with-preview": !!asset.tn_path
                });
                var style = asset.tn_path ? {
                    backgroundImage: "url(".concat(asset.tn_path, ")")
                } : null;
                return /*#__PURE__*/ React.createElement("li", {
                    className: assetCss,
                    key: asset.id
                }, /*#__PURE__*/ React.createElement("a", {
                    className: "attachment__link",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: asset.path,
                    title: asset.name,
                    style: style ? style : {}
                }, /*#__PURE__*/ React.createElement("span", {
                    className: "attachment__type"
                }, last(asset.name.split("."))), !asset.tn_path && asset.name));
            })) : null;
        };
        _this.renderTopic = function(topic) {
            var _this_props = _this.props, intl = _this_props.intl, isNote = _this_props.isNote;
            var lastUpdate = topic.updated_at ? topic.updated_at : topic.created_at;
            var userClasses = classNames("social-topic__meta", {
                "user-inactive": topic.owner.is_active === false
            });
            var userTooltip = topic.owner.is_active === false ? intl.formatMessage({
                id: "social.users.inactive_title",
                defaultMessage: "inactive"
            }) : "";
            return /*#__PURE__*/ React.createElement("div", {
                className: "social-topic",
                ref: function(el) {
                    return _this.topic = el;
                },
                onScroll: hasClassList ? _this._onScroll : null
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "social-topic__header"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "social-topic__header-text"
            }, topic.title), /*#__PURE__*/ React.createElement("small", {
                className: userClasses,
                title: userTooltip
            }, /*#__PURE__*/ React.createElement(SocialMemberBubble, {
                isNote: isNote,
                members: [
                    topic.owner
                ],
                iconSize: "s"
            }), !isNote ? intl.formatMessage({
                id: "social.activities._title_created_by_at_",
                defaultMessage: "created by {user}"
            }, {
                updated: !!topic.updated_at,
                user: topic.owner.name.split(" ")[0],
                at: intl.formatRelative(1000 * lastUpdate)
            }) : intl.formatMessage({
                id: "social.activities.created_at_",
                defaultMessage: "created at {updated}"
            }, {
                updated: !!topic.updated_at,
                at: intl.formatRelative(1000 * lastUpdate)
            }))), /*#__PURE__*/ React.createElement("div", {
                className: "social-topic__description",
                dangerouslySetInnerHTML: {
                    __html: topic.description ? linkify(topic.description.body) : ""
                }
            }), topic.description ? _this.renderAssets(topic.description) : null, !_this.props.isNote ? /*#__PURE__*/ React.createElement(SocialActivities, {
                onEdit: _this.props.onEditActivity,
                onDelete: _this.props.onDeleteActivity
            }) : null);
        };
        _this._toggleDeleteDropdownState = function() {
            _this.setState({
                deleteDropdownOpen: !_this.state.deleteDropdownOpen
            });
        };
        _this._hideDeleteDropdownState = function() {
            _this.setState({
                deleteDropdownOpen: false
            });
        };
        _this._onEditTopic = function(evnt) {
            evnt.preventDefault();
            var newIsEditing = !_this.state.isEditing;
            _this.setState({
                isEditing: newIsEditing
            });
            if (isFunction(_this.props.onEditTopic)) {
                _this.props.onEditTopic(newIsEditing);
            }
        };
        _this._onNewAnswer = function(evnt) {
            evnt.preventDefault();
            if (isFunction(_this.props.onNewAnswer)) {
                _this.props.onNewAnswer();
            }
        };
        _this._onScroll = function() {
            var element = _this.topic;
            if (!element.classList.contains("scroller") && element.scrollTop > 5) {
                element.classList.add("scroller");
            }
            if (element.scrollTop <= 5) {
                element.classList.remove("scroller");
            }
        };
        _this._onShare = function(evnt) {
            evnt.preventDefault();
            if (_this.props.onShare) {
                _this.props.onShare(_this.props.topic);
            }
        };
        _this._onDeleteNote = function(evnt) {
            evnt.preventDefault();
            if (_this.props.onDeleteTopic) {
                _this.props.onDeleteTopic(_this.props.topic);
            }
        };
        _this.state = {
            sphere: null,
            deleteDropdownOpen: false,
            isEditing: false
        };
        return _this;
    }
    var _proto = SocialTopic.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // TO DO: solve this via container
        store.dispatch(fetchAvatars({}));
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (!isEqual(prevProps.topic, this.props.topic)) {
            // TO DO: solve this via container
            store.dispatch(fetchAvatars({}));
        }
    };
    _proto.render = function render() {
        var _this_props = this.props, intl = _this_props.intl, className = _this_props.className;
        var filterTypes = [
            {
                value: 1,
                txt: intl.formatMessage({
                    id: "social.activities._title_nodes_filter_cbook",
                    defaultMessage: "cBOOK"
                })
            },
            {
                value: 2,
                txt: intl.formatMessage({
                    id: "social.activities._title_nodes_filter_current_chart",
                    defaultMessage: "Current Slide"
                })
            }
        ];
        return /*#__PURE__*/ React.createElement("div", {
            className: className
        }, /*#__PURE__*/ React.createElement("div", {
            className: "social-app-options"
        }, this.props.isEditable && /*#__PURE__*/ React.createElement("button", {
            onClick: this._onEditTopic,
            className: "social-app-options__btn social-app-options__btn--secondary"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "edit",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "social-app-options__btn-text"
        }, !this.props.isNote ? intl.formatMessage({
            id: "social.activities.edit_topic",
            defaultMessage: "edit topic"
        }) : intl.formatMessage({
            id: "social.notes.edit_note",
            defaultMessage: "edit note"
        }))), !this.props.isNote ? /*#__PURE__*/ React.createElement("button", {
            onClick: this._onNewAnswer,
            className: "social-app-options__btn"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "add",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "social-app-options__btn-text"
        }, intl.formatMessage({
            id: "social.activities.create_new_answer",
            defaultMessage: "create new answer"
        }))) : /*#__PURE__*/ React.createElement("button", {
            onClick: this._onShare,
            className: "social-app-options__btn"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "share",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "social-app-options__btn-text"
        }, intl.formatMessage({
            id: "social.notes.share",
            defaultMessage: "share"
        }))), this.props.onDeleteTopic && /*#__PURE__*/ React.createElement("button", {
            onClick: this._onDeleteNote,
            className: "social-app-options__btn"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "delete",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "social-app-options__btn-text"
        }, intl.formatMessage({
            id: "social.notes.delete_note",
            defaultMessage: "delete note"
        })))), !!this.props.topic && this.renderTopic(this.props.topic));
    };
    return SocialTopic;
}(_React_Component = React.Component);
SocialTopic.displayName = "SocialTopic";
SocialTopic.defaultProps = {
    isEditing: false,
    deleteDropdownOpen: false
};
export default injectIntl(SocialTopic);
